<template>
    <div class="wrapper ">
        <Sidebar />
        <div class="main-panel" id="main-panel">
            <Header />
            <div class="panel-header panel-header-sm">
                <canvas id="bigDashboardChart"></canvas>
            </div>
            <div class="content">

                <Loading v-if="loading === true" />

                <!-- IF THIS IS A SUPER ADMIN, SHOW THESE BOXES -->
                <div v-if="isSuperAdmin === true">
                    <div class="row">

                        <div class="col">
                            <div class="card">
                                <div class="card-header">
                                    <h5>Total Institutes</h5>
                                </div>
                                <div class="card-body">
                                    <h5>Total: <b>{{ museumCount }}</b></h5>
                                    <small style="font-size: 15px;"><a href="/institutes/"><b>Manage</b></a></small>
                                </div>
                            </div>
                        </div>

                        <div class="col">
                            <div class="card">
                                <div class="card-header">
                                    <h5>Total Curators</h5>
                                </div>
                                <div class="card-body">
                                    <h5>Total: <b>{{ curatorCount }}</b></h5>
                                    <small style="font-size: 15px;"><a href="/users/"><b>Manage</b></a></small>
                                </div>
                            </div>
                        </div>

                        <div class="col">
                            <div class="card">
                                <div class="card-header">
                                    <h5>Registered Users</h5>
                                </div>
                                <div class="card-body">
                                    <h5>Total: <b>{{ memberCount }}</b></h5>
                                    <small style="font-size: 15px;"><a href="/members/"><b>Manage</b></a></small>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="row">
                        <div class="col">
                            <div class="card">
                                <div class="card-header">
                                    <h5>Total Artworks in Catalog</h5>
                                </div>
                                <div class="card-body">
                                    <h5>Total: <b>{{ listingCount }}</b></h5>
                                    <small style="font-size: 15px;"><a href="/listings/"><b>Manage</b></a></small>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="card">
                                <div class="card-header">
                                    <h5>Artworks Pending Approval</h5>
                                </div>
                                <div class="card-body">
                                    <h5 class="mb-1">Total: <b>{{ unapprovedListingsCount }}</b></h5>
                                    <small style="font-size: 15px;"><a href="/listings/review"><b>Click here to review</b></a></small>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="card">
                                <div class="card-header">
                                    <h5>Active Events</h5>
                                </div>
                                <div class="card-body">
                                    <h5>Total: <b>{{ eventCount }}</b></h5>
                                    <small style="font-size: 15px;"><a href="/events/"><b>Manage</b></a></small>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div v-if="isSuperAdmin !== true">
                    <div class="row">
                        <div class="col">
                            <div class="card">
                                <div class="card-header">
                                    <h5>Artworks Pending Verification</h5>
                                </div>
                                <div class="card-body">
                                    <h5 class="mb-0">Total: <b>{{ unverifiedMuseumCount }}</b></h5>
                                    <small style="font-size: 15px;"><a href="listings/review"><b>Click here to review</b></a></small>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="card">
                                <div class="card-header">
                                    <h5>Upcoming Institute Events</h5>
                                </div>
                                <div class="card-body">
                                    <h5>Total: <b>{{ eventCountForMuseum }}</b></h5>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="card">
                                <div class="card-header">
                                    <h5>Total Artworks in Catalog</h5>
                                </div>
                                <div class="card-body">
                                    <h5>Total: <b>{{ listingForMuseumCount }}</b></h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <Footer />
        </div>
    </div>
</template>

<script>
    import Listings from '../controllers/listing.controller';
    import Museums from '../controllers/museum.controller';
    import Members from '../controllers/members.controller';
    import Events from '../controllers/events.controller';
    import isSuperAdmin from '../services/jwt/isSuperAdmin';
    import getUID from '../services/jwt/getUID';
    import Admin from "@/controllers/admin.controller";

    export default {
        name: 'Dashboard',
        data: function() {
            return {
                loading: false,
                isSuperAdmin: isSuperAdmin(localStorage.getItem('superAdmin')),
                museumCount: 0,
                listingCount: 0,
                unapprovedListingsCount: 0,
                memberCount: 0,
                curatorCount: 0,
                eventCount: 0,
                eventCountForMuseum: 0,
                listingForMuseumCount: 0,
                unverifiedMuseumCount: 0
            }
        },
        beforeMount: async function() {
            this.loading = true;

            if (this.isSuperAdmin === true) {
                this.museumCount = await Museums.getTotalCount();
                this.listingCount = await Listings.getTotalCount();
                this.unapprovedListingsCount = await Listings.getUnapprovedCount();
                this.memberCount = await Members.getTotalCount();
                this.curatorCount = await Admin.getCuratorCount();

                let events = await Events.getAll();
                this.eventCount = events !== false ? events.events.length : 0;

            } else {
                let listingCount = 0;
                let eventCount = 0;
                let unverifiedCount = 0;
                let uid = await getUID(localStorage.getItem('superAdmin'));

                let curatorMuseums = await Museums.getCuratorMuseums(uid);

                for (const museum of curatorMuseums) {
                    unverifiedCount += await Listings.getUnverifiedCount(museum.id);
                    listingCount += await Listings.countForMuseum(museum.id);

                    let events = await Events.getByMuseumID(museum.id);
                    if (events !== false) {
                      eventCount += await events.length;
                    }
                }

                this.listingForMuseumCount = listingCount;
                this.eventCountForMuseum = eventCount;
                this.unverifiedMuseumCount = unverifiedCount;
            }

            this.loading = false
        }
    }
   
</script>